/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExecuteCashOutRequest} from '@cash-web/protos/squareup/cash/out/api/v1_0/ExecuteCashOut.pb'
import {ExecuteCashOutResponse} from '@cash-web/protos/squareup/cash/out/api/v1_0/ExecuteCashOut.pb'


export const executeCashOut = (request: ExecuteCashOutRequest, options?: CashRequestOptions) => post<ExecuteCashOutRequest, ExecuteCashOutResponse>("/2.0/cash/execute-cash-out", request, {...options, rejectOnError: true })